import { render, staticRenderFns } from "./outbound-email-failed-icon.vue?vue&type=template&id=068cfe72"
import script from "./outbound-email-failed-icon.vue?vue&type=script&lang=js"
export * from "./outbound-email-failed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports